import React from 'react';

import { InputAdornment } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { ConnectingLinesNode } from '@dyl/components/ConnectingLines';
import { Adjust } from '@mui/icons-material';


const useNodeStyles = makeStyles(theme => ({
    icon: {
        color: theme.palette.grey['600'],
    },
}));

export default function Node({ side, lineId }) {
    const classes= useNodeStyles();
    return (
        <InputAdornment position={side === 'start' ? 'end' : 'start'}>
            <ConnectingLinesNode
                lineId={lineId}
                side={side}
                component={Adjust}
                className={classes.icon}
            />
        </InputAdornment>
    );
}